import { SORTBY_OPTIONS } from '../../constants/commonConstants';
import networkActions from '../constants/networkActionConstants';

const initialState = {
  contacts: [],
  pageInfo: {},
  searchTerm: '',
  sortby: SORTBY_OPTIONS[2],
  tags: [],
  sources: [],
  syncSources: [],
  csvImportHistory: [],
  networksLoading: false,
  importHistoryCount: {},
};

const networkReducer = (state = initialState, action = {}) => {
  switch (action.type) {
    case networkActions.GET_CONTACTS:
      return {
        ...state,
        contacts: action.payload.contacts,
        pageInfo: action.payload.page_info,
      };
    case networkActions.SET_SEARCH:
      return {
        ...state,
        searchTerm: action.payload,
      };
    case networkActions.SET_SORTBY:
      return {
        ...state,
        sortby: action.payload,
      };
    case networkActions.GET_TAGS:
      return {
        ...state,
        tags: action.payload,
      };
    case networkActions.BULK_DELETE_CONTACTS:
      return {
        ...state,
        contacts: state.contacts.filter((obj) => !action.payload.includes(obj.id)),
      };

    case networkActions.UPDATE_USER_CONTACTS: {
      const newContacts = [...state.contacts];
      const index = state.contacts.findIndex((contact) => contact.id === action.payload.id);
      if (index !== -1) {
        newContacts[index] = action.payload;
      }
      return {
        ...state,
        contacts: newContacts,
      };
    }

    case networkActions.GET_SYNC_DATA:
      return {
        ...state,
        syncSources: action.payload,
      };

    case networkActions.TOGGLE_CONNECT_SYNC:
      return {
        ...state,
        syncSources: state.syncSources.map((source) => {
          if (source.id === action.payload) {
            return { ...source, is_synced: !source.is_synced };
          }
          return source;
        }),
      };
    case networkActions.DELETE_SYNC:
      return {
        ...state,
        syncSources: state.syncSources.filter(({ id }) => id !== action.payload),
      };
    case networkActions.GET_IMPORT_HISTORY:
      return {
        ...state,
        csvImportHistory: action.payload,
      };
    case networkActions.GET_IMPORT_HISTORY_COUNT:
      return {
        ...state,
        importHistoryCount: action.payload,
      };
    case networkActions.DELETE_IMPORT_HISTORY:
      return {
        ...state,
        csvImportHistory: state.csvImportHistory.filter((data) => data.id !== action.payload),
      };
    case networkActions.SET_NETWORK_LOADING_ON:
      return {
        ...state,
        networksLoading: true,
      };
    case networkActions.SET_NETWORK_LOADING_OFF:
      return {
        ...state,
        networksLoading: false,
      };
    default:
      return state;
  }
};

export default networkReducer;
